import React from 'react';
import { Box, Button } from '@clariness/clarikit-react';
import { Environment } from 'global/environment';
import { setAuthProvider } from 'utils/auth';
import { useIntl } from 'react-intl';

export const Auth0SsoButton: React.FC = () => {
  const intl = useIntl();

  const redirectToAuth0Sso = (): void => {
    setAuthProvider('auth0-sso');
    const authorizeUrl = new URL(
      Environment.AUTH0_SSO_AUTHORIZATION_ENDPOINT ||
        `https://${Environment.AUTH0_DOMAIN}/authorize`
    );
    authorizeUrl.searchParams.set(
      'client_id',
      Environment.AUTH0_SSO_CLIENT_ID || ''
    );
    authorizeUrl.searchParams.set(
      'redirect_uri',
      Environment.AUTH0_SSO_REDIRECT_URI || ''
    );
    authorizeUrl.searchParams.set(
      'response_type',
      Environment.AUTH0_SSO_RESPONSE_TYPE || 'code'
    );
    authorizeUrl.searchParams.set(
      'scope',
      Environment.AUTH0_SSO_SCOPE || 'openid'
    );

    window.location.href = authorizeUrl.toString();
  };

  return (
    <Box width="60%">
      <Button
        fullWidth
        size="l"
        variant="primary"
        colorVariant="green"
        onClick={redirectToAuth0Sso}
        data-test-id="IS-login-auth0-sso-button"
      >
        {intl.formatMessage({
          id: 'is.sso-login.button',
          defaultMessage: 'Sign in with SSO',
        })}
      </Button>
    </Box>
  );
};
